<template>
  <div class="uikit_qa">
    <div class="uikit_qa_question_wrapper">
      <div class="uikit_qa_question">
        <div class="uikit_qa_avatar text">
          <h4>PT</h4>
        </div>
        <h5 class="uikit_qa_text">{{ qa.question }}</h5>
      </div>
    </div>
    <div class="uikit_qa_question_wrapper">
      <div class="uikit_qa_answer">
        <img class="uikit_qa_avatar" src="/images/dash.png" />
        <h5 class="uikit_qa_text">{{ qa.answer }}</h5>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UikitQA",
  props: {
    qa: Object,
  },
};
</script>

<style scoped>
.uikit_qa {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.uikit_qa_question,
.uikit_qa_answer {
  display: flex;
  max-width: 768px;
  width: 100%;
  padding: 10px;
  gap: 24px;
}
.uikit_qa_question_wrapper {
  display: flex;
  justify-content: center;
  padding: 16px;
  gap: 24px;
  width: 100%;
  box-sizing: border-box;
}
.uikit_qa_question_wrapper:nth-child(even) {
  background: #444654;
}
.uikit_qa_avatar {
  height: 20px;
  width: 20px;
  padding: 4px;
  background: #10a37f;
}
.uikit_qa_avatar.text {
  background: #5f4bb6;
}
.uikit_qa_text {
  text-align: left;
  font-size: 16px;
  line-height: 28px;
  letter-spacing: normal;
  font-weight: 400;
  user-select: text !important;
}
</style>
